import { useMemo, useState, type ReactNode } from 'react';
import { initialLang, saveLang, type Lang } from '@/features/survey/i18n';
import { MINIONS_STRINGS, MinionsI18nContext } from '../i18n';
import { makeFormat } from '../format';

/** Holds the page's language — the Système U choice, remembered for the viewer's next visit. */
export function MinionsI18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(initialLang);
  const value = useMemo(
    () => ({
      lang,
      t: MINIONS_STRINGS[lang],
      f: makeFormat(lang),
      setLang: (next: Lang) => {
        setLang(next);
        saveLang(next);
      },
    }),
    [lang],
  );
  return <MinionsI18nContext.Provider value={value}>{children}</MinionsI18nContext.Provider>;
}
